<template>
  <div v-loading="loading">
    <div class="card table-header mt-4">
      <div class="flex justify-between">
        <div class="group-options-select">
          <form-select @change-group-type="changeGroupType($event)" />
        </div>

        <router-link :to="{ name: 'AddNewGroup' }">
          <primary-button buttonText="Add New Group" />
        </router-link>
      </div>

      <div class="responsive-table" id="table-wrapper">
        <table class="custom-table responsive-table border-collapse">
          <thead>
            <tr class="shadow-sm rounded">
              <!-- <th class="checkbox">
                <base-checkbox />
              </th> -->
              <th>Group Name</th>
              <th>Description</th>
              <th>Admin</th>
              <th>Members</th>
              <th>Date Created</th>
              <th tabindex="-1">
                <span class="cursor-pointer">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.7">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                        fill="#383F51" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                        fill="#383F51" />
                    </g>
                  </svg></span>
              </th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <tr v-for="group in filteredGroups" :key="group.id" class="shadow-sm rounded">
              <!-- <td>
                <base-checkbox />
              </td> -->
              <td class=" whitespace-no-wrap">{{ group.name }}</td>
              <td>{{ group.description }}</td>
              <td>{{ group.superAdmin ? group.superAdmin.fname + " " + group.superAdmin.lname : "-" }}</td>
              <td>{{ group.membersCount }}</td>
              <!-- <td v-if="group.groupusers">{{ group.groupusers.length }}</td>
              <td v-else>-</td> -->
              <td>{{ group.createdAt | formatDate }}</td>
              <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer">
                <span @click="showActionOptions(group.id)">
                  <vertical-ellipsis />
                </span>
                <div class="table__action-options" v-if="selectedRowId == group.id">

                  <div class="table__action-option cursor-pointer" @click="viewSingleGroup(group)">
                    <p>View Group</p>
                  </div>
                  <div class="table__action-option cursor-pointer" @click="editGroup(group)">
                    <p>Edit Group</p>
                  </div>
                  <div class="table__action-option cursor-pointer" @click="showDeactivateModal(group)">
                    <p>Deactivate Group</p>
                  </div>
                  <div class="table__action-option cursor-pointer" @click="showDeleteModal(group)">
                    <p>Delete Group</p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="!filteredGroups.length">
          <empty-users-icon />

          <p class="text-center text-sm font-bold" style="color: #fcc210">
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="inline">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M11 22.4004C4.92487 22.4004 0 17.4755 0 11.4004C0 5.32526 4.92487 0.400391 11 0.400391C17.0751 0.400391 22 5.32526 22 11.4004C22 17.4755 17.0751 22.4004 11 22.4004ZM11 20.4004C15.9706 20.4004 20 16.371 20 11.4004C20 6.42983 15.9706 2.40039 11 2.40039C6.02944 2.40039 2 6.42983 2 11.4004C2 16.371 6.02944 20.4004 11 20.4004ZM16 10.4004H12V6.40039H10V10.4004H6V12.4004H10V16.4004H12V12.4004H16V10.4004Z"
                fill="#FCC210" />
            </svg>
            Start Adding Groups
          </p>
        </div>
      </div>
      <pagination-control />
      <group-acces-revoker :show-modal="isDeactivateModal" @close-modal="isDeactivateModal = false"
        @group-deactivated="getAllGroups" :group="selectedGroup" />
      <delete-group-modal :show-modal="isDeleteModal" @close-modal="isDeleteModal = false" @group-deleted="getAllGroups"
        :group="selectedGroup" />

    </div>
  </div>
</template>

<script>
// import Pagination from "@/components/UI/pagination";
import PaginationControl from "@/components/UI/NewPagination";
import FormSelect from "../FormSelect";
import GroupAccesRevoker from "../Modals/GroupAccesRevoker";
import DeleteGroupModal from "../Modals/DeleteGroupModal";

// import FormSelect from "./FormSelect";
export default {
  // name: 'groups-table',
  components: {
    // Pagination,
    PaginationControl,
    FormSelect,
    GroupAccesRevoker,
    DeleteGroupModal
    // FormSelect,
  },
  props: ["fetchGroups"],
  data() {
    return {
      selectedRowId: null,
      selectedOption: "functional",
      options: [
        { value: "functional", text: "Functional" },
        { value: "management", text: "Management" },
        { value: "projects", text: "Projects" },
      ],
      isDeactivateModal: false,
      isDeleteModal: false,
      groupTypes: ['Functional', 'Management', 'Projects'],
      groups: [],
      loading: true,
      selectedGroup: {},
      groupType: "Functional",
      queryString: "",
      sortList: false,
    };
  },
  computed: {
    filteredGroups() {
      let groups = this.filterArray(this.groups, this.queryString);
      // return this.groups;
      return this.sortList
        ? groups.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        })
        : groups;
    },
    UGQueryString() {
      return this.$store.getters.getUserAndGroupsQuery;
    },
    UGQuerySortList() {
      return this.$store.getters.userAndGroupSortList;
    },
  },
  mounted() {
    this.getAllGroups();
  },
  watch: {
    groupType() {
      this.isGroupInLocalStorage(this.groupType);
      this.getAllGroups();
    },
    UGQueryString(value) {
      this.queryString = value;
    },
    UGQuerySortList(value) {
      this.sortList = value;
    },
  },
  methods: {
    async getAllGroups() {
      this.loading = true;
      try {
        let response;
        if (this.groupType == "Functional") {
          response = await this.$_getFunctionalGroups();
          this.groups = response.data.groups
        } else if (this.groupType == "Management") {
          response = await this.$_getManagementGroups();
          this.groups = response.data.groups;
        } else if (this.groupType == "Projects") {
          response = await this.$_getProjectGroups();
          this.groups = response.data.groups;
        } else {
          // response = await this.$_getAllGroups();
          response = await this.$_getFunctionalGroups();
          this.groups = response.data.functions
        }
        console.log(response);
        this.loading = false;
        // this.groups = response.data.group.filter((group) => {
        //   return group.isDeactivated == "false";
        // });
        this.saveGroupToLocalStorage();
      } catch (error) {
        this.handleError(error);
        console.log(error);
        this.loading = false;
      }
    },
    saveGroupToLocalStorage() {
      if (this.groupType == "Functional") {
        localStorage.setItem("functionalGroups", JSON.stringify(this.groups));
      } else if (this.groupType == "Management") {
        localStorage.setItem("managementGroups", JSON.stringify(this.groups));
      } else if (this.groupType == "Projects") {
        localStorage.setItem("projectsGroups", JSON.stringify(this.groups));
      }
    },
    isGroupInLocalStorage(groupType) {
      groupType = groupType.toLowerCase();
      groupType = groupType + "Groups";
      let group = JSON.parse(localStorage.getItem(groupType));
      if (group) {
        this.groups = group;
      } else {
        this.getAllGroups();
      }
    },
    viewSingleGroup(group) {
      localStorage.setItem("viewGroup", JSON.stringify(group));
      this.$router.push("/settings/users-and-groups/view-group");
    },
    changeGroupType(groupType) {
      this.groupType = groupType;
    },
    showDeactivateModal(group) {
      this.selectedGroup = group;
      this.isDeactivateModal = true;
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    showDeleteModal(group) {
      this.selectedGroup = group;
      this.isDeleteModal = true;
    },
    showViewRoleModal() {
      this.$emit("show-view-role-modal");
      this.resetSelectedRow();
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
    editGroup(group) {
      localStorage.setItem("editedGroup", JSON.stringify(group));
      this.$router.push({ name: "EditGroup" });
    },
  },
};
</script>
